import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommonButton from 'app/components/ReviewButton';
import { DATE_RANGE_KEYS } from 'app/constants/filters';
import { TRANSLATION_KEYS } from 'app/constants/transalations';
import { encodeURL } from 'app/utils/helpers';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { CLUSTERING } from 'store/reviewData/constants';

type ViewClusteringButtonProps = {
  clusterRunId: number;
};

export const ViewClusteringButton = ({
  clusterRunId,
}: ViewClusteringButtonProps) => {
  const { t } = useTranslation(TRANSLATION_KEYS.REVIEW);
  const { subscriptionId, packId } = useParams();

  const handleViewClusteringClick = () => {
    const params = queryString.stringify({
      contextual_filters: encodeURL({
        date: DATE_RANGE_KEYS.ALL_DATE_RANGE,
        cluster_run_id: clusterRunId,
      }),
    });
    window.open(
      `/${subscriptionId}/${packId}/annotation/${CLUSTERING}?${params}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <CommonButton
      text={t('View clustering')}
      onClick={handleViewClusteringClick}
      variant='tertiary'
      icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
    />
  );
};
